// src/pages/Contact.js
import React from 'react';

function Contact() {
  return (
    <div className="w3-container">
      <h1 className="w3-center">Contact</h1>

      <p>Hearties lass grapple lad Barbary Coast rutters bucko. Fire in the hole walk the plank scourge of the seven seas Sail ho dead men tell no tales log Chain Shot. Six pounders scuttle American Main belay crack Jennys tea cup overhaul chase.</p>
    </div>
  )
}

export default Contact;